/**
 * DREAM39/DREAM40 — money is stored as INTEGER cents everywhere on the
 * backend (never a float), so this is the one place cents <-> dollars
 * conversion happens. No money formatter existed in the repo before this.
 */

export function fmtMoney(cents: number | null | undefined, currency = 'USD'): string {
  const value = (cents ?? 0) / 100;
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value);
}

/** Value suitable for a text input showing dollars, e.g. 8000 -> "80.00". */
export function fmtCentsInput(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return '';
  return (cents / 100).toFixed(2);
}

/**
 * Parses a user-typed dollar amount into integer cents. Strips `$`, `,`,
 * and surrounding whitespace; rejects more than 2 decimal places or a
 * non-numeric value. Returns null on anything invalid so the caller can
 * show an inline error instead of silently coercing to 0.
 */
export function parseMoneyToCents(input: string): number | null {
  const cleaned = input.replace(/[$,\s]/g, '');
  if (cleaned === '') return null;
  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  return Math.round(parseFloat(cleaned) * 100);
}
